import { COLUMN_WIDTHS } from '@mts/shared/containerLayout';

export function contentEditorItemSizingAvailable(editor, selection) {
  return Boolean(editor && selection && selection.node.type.name !== 'column' && editor.state.doc.resolve(selection.position).parent.type.name === 'container' && Object.hasOwn(selection.node.attrs, 'layoutSizing'));
}

/** Sizing belongs to an item in a layout, independently of its own contents. */
export function ContentEditorItemSizing({ editor, selection, disabled, onUpdate }) {
  if (!contentEditorItemSizingAvailable(editor, selection)) return null;
  const attrs = selection.node.attrs;
  const value = attrs.layoutSizing === 'fixed' ? attrs.layoutWidth || 'full' : attrs.layoutSizing || 'fit';
  return <label>Item width<select disabled={disabled} value={value} onChange={(event) => {
    const next = event.target.value;
    onUpdate(COLUMN_WIDTHS.includes(next) ? { layoutSizing: 'fixed', layoutWidth: next } : { layoutSizing: next, layoutWidth: null });
  }}><option value="fit">Fit content</option><option value="grow">Fill available space</option>{COLUMN_WIDTHS.filter((width) => width !== 'auto').map((width) => <option key={width} value={width}>{width === 'full' ? '100%' : width}</option>)}</select></label>;
}
